import React, { useContext, useState } from "react";
import { urls } from "../../URLs";
import { BASE_URL_API_TRANXT_API, BASE_URL_APISERVICES } from "../../utils/Constants";
import { useHistory } from "react-router";
import swal from "sweetalert";
import cogoToast from "cogo-toast";
import { GlobalContext } from "../../Context/GlobalState";
import { auth } from "../../utils/firebase/firebase.config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { generateHashKey2 } from "../../utils/utilFuctions";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";

export default function ForgetPasswordAdmin() {
  const history = useHistory();
  const { login: loginUrl } = urls;
  const [userName, setUserName] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [forgetSuccess, setForgetSuccess] = useState(false);
  const [textOtp, setTextOtp] = useState("");
  const [resendOtpEnable, setResendOtpEnable] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const { setTransactionLoaderState, setUserInfo, user } =
    useContext(GlobalContext);
  const [formErrors1, setFormErrors1] = useState({ mobile: "" });
  const [formErrors3, setFormErrors3] = useState({ otp: "" });
  const [contry, setCountry] = useState("+91");
  const [formErrors2, setFormErrors2] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [passShow, setPassShow] = useState(false);
  const [passShow2, setPassShow2] = useState(false);
  // const [userType, setUserType] = useState("");

  // NEW OTP FLOW
  const [loading, setLoading] = useState(false);

  function onCaptchVerify() {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {},
          "expired-callback": () => {},
        },
        auth
      );
      onSignup();
    }
  }

  function onSignup() {
    onCaptchVerify();

    const appVerifier = window.recaptchaVerifier;

    const formatPh = contry + userName;
    console.log(formatPh);

    signInWithPhoneNumber(auth, formatPh, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        cogoToast.success("OTP sended successfully!");
        setOtpSent(true);
        setResendOtpEnable(false);
        setSeconds(60);
      })
      .catch((error) => {
        console.log(error);
        //  cogoToast.error("OTP not sent");
        setLoading(false);
      });
  }

  function onOTPVerify() {
    setLoading(true);
    window.confirmationResult
      .confirm(textOtp)
      .then(async (res) => {
        cogoToast.success("OTP validated successfully!");
        setOtpValidated(true);
      })
      .catch((err) => {
        cogoToast.error("Invalid OTP");
        console.log(err);
      });
  }

  const goTOLoginScreen = () => history.push("/");

  const sendOTP2 = async () => {
    setTransactionLoaderState(true);

    var raw = JSON.stringify({
      mobileno: userName,
      otpvalue: "",
    });

    const hash_key = await generateHashKey2(userName);
    var myHeaders = new Headers();
    myHeaders.append("HASH_KEY", hash_key);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Profile/otpsendone.aspx`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "00") {
        cogoToast.success(data.msg.toString());
        setOtpSent(true);
      } else {
        cogoToast.success(data.msg.toString());
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const sendOTP = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        mobile: userName,
        password: "",
        step: "1",
        otp: "",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.forgetPassword}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        cogoToast.success(data.msg.toString());
        setOtpSent(true);
      } else {
        cogoToast.success(data.msg.toString());
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const validateOTP2 = async () => {
    setTransactionLoaderState(true);

    var raw = JSON.stringify({
      mobileno: userName,
      otpvalue: textOtp,
    });
    const hash_key = await generateHashKey2(userName);
    var myHeaders = new Headers();
    myHeaders.append("HASH_KEY", hash_key);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Profile/otpsendtwo.aspx`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "00") {
        // swal("Success", data.msg, "success");
        //  changePassword();
        setOtpValidated(true);
      } else {
        swal("Failed", data.msg, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };
  const validateOTP = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        mobile: userName,
        password: newPassword,
        step: "2",
        otp: textOtp,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.forgetPassword}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
         swal("Success", data.msg, "success");
        setOtpValidated(true);
      } else {
        swal("Failed", data.msg, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const changePassword = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        mobile: userName,
        password: newPassword,
        step: "2",
        otp: textOtp,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.forgetPassword}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "00") {
        // swal("Success", data.msg, "success");
        //  changePassword();
        setOtpValidated(true);
      } else {
        swal("Failed", data.msg, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };


  const validate1 = () => {
    let errors = {};
    if (userName.length != 10) {
      errors.mobile = "please enter valid mobile number";
    }
    setFormErrors1(errors);
    if (Object.keys(errors).length === 0) {
      if (contry == "+91") {
        sendOTP();
      } else {
        onSignup();
      }
    } else {
      setFormErrors1(errors);
    }
  };
  const showNewPassword = () => {
    setPassShow(!passShow);
  };
  const showConfirmPassword = () => {
    setPassShow2(!passShow2);
  };
  return (
    <div
      className="row justify-content-center align-items-center my-auto mx-auto mt-5"
      style={{
        height: "100vh",
        background: "linear-gradient(to right, #EBEEF1, #EBEEF1)",
      }}
    >
      <div id="recaptcha-container"></div>
      <div className="col-lg-4 col-md-8 col-sm-10 mx-auto">
        {forgetSuccess && <ForgetSuccess history={history} />}

        {!forgetSuccess && (
          <div className="card text-left p-4">
            <h4 className="px-5"> Forget Password</h4>

            {!otpSent && (
              <React.Fragment>
                <div className="form-group m-0 p-0 ">
                  <label className="px-5 m-0 mt-2 ">Mobile number</label>
                  <div className="input-group input-group-sm px-5 mt-3">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0 no-glow">
                        <select
                          onChange={(e) => {
                            setCountry(e.target.value);
                          }}
                          style={{
                            padding: "4px",
                            border: "none",
                            outline: "none",
                          }}
                        >
                          {["+91", "+1"].map((en) => (
                            <option>{en}</option>
                          ))}
                        </select>
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control form-control-lg border-left-0 no-glow"
                      id="exampleInputEmail"
                      placeholder="Username"
                      onChange={(e) => {
                        setFormErrors1({ mobile: "" });
                        setUserName(e.target.value);
                      }}
                    />
                  </div>
                  <p className="text-danger text-left p-0">
                    {formErrors1.mobile}
                  </p>
                </div>

                <div className="row px-4 mx-4">
                  <button
                    style={{ flex: "1" }}
                    className="btn btn-primary flex-1 rounded-1"
                    onClick={validate1}
                  >
                    Send OTP
                  </button>
                </div>
              </React.Fragment>
            )}

            {otpSent && (
              <React.Fragment>
                <div className="form-group m-0 p-0 ">
                  <label className="row px-4 mx-4"> OTP</label>
                  <div className="input-group px-5">
                    <input
                      type="password"
                      className="form-control form-control-lg no-glow"
                      id="exampleInputPassword"
                      placeholder="Enter OTP"
                      onChange={(e) => {
                        setError("");
                        setTextOtp(e.target.value);
                      }}
                      value={textOtp}
                    />
                  </div>
                  <p className="text-danger text-left p-0">{formErrors3.otp}</p>
                </div>
                <div className="form-group px-5 m-0">
                  <label> New Password</label>
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0 no-glow">
                        <i className="mdi mdi-lock-outline text-primary"></i>
                      </span>
                    </div>
                    <input
                      type={passShow ? "text" : "password"}
                      className="form-control form-control-lg border-left-0 border-right-0 no-glow"
                      id="exampleInputPassword"
                      placeholder="new password"
                      onChange={(e) => {
                        setError("");
                        setNewPassword(e.target.value);
                      }}
                      value={newPassword}
                    />
                    <div className="input-group-prepend bg-transparent">
                      <span
                        className="input-group-text bg-transparent border-left-0 no-glow"
                        onClick={showNewPassword}
                      >
                        <i
                          className={`mdi text-primary ${
                            passShow ? "mdi-eye" : "mdi-eye-off"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <p className="text-danger text-left p-0">
                    {formErrors2.newPassword}
                  </p>
                </div>

                <div className="form-group px-5 m-0 ">
                  <label> Confirm Password</label>
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0 no-glow">
                        <i className="mdi mdi-lock-outline text-primary"></i>
                      </span>
                    </div>
                    <input
                      type={passShow2 ? "text" : "password"}
                      className="form-control form-control-lg border-left-0 border-right-0 no-glow"
                      id="exampleInputPassword"
                      placeholder="confirm password"
                      onChange={(e) => {
                        setError("");
                        setConfirmPassword(e.target.value);
                      }}
                      value={confirmPassword}
                    />
                    <div className="input-group-prepend bg-transparent">
                      <span
                        className="input-group-text bg-transparent border-left-0 no-glow"
                        onClick={showConfirmPassword}
                      >
                        <i
                          className={`mdi text-primary ${
                            passShow2 ? "mdi-eye" : "mdi-eye-off"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <p className="text-danger text-left p-0">
                    {formErrors2.confirmPassword}
                  </p>
                </div>
                <div className="row px-4 mx-4">
                  <button
                    style={{ flex: "1" }}
                    className="btn btn-primary rounded-1"
                    onClick={validateOTP}
                  >
                    Reset Password
                  </button>
                </div>
              </React.Fragment>
            )}
            <div className="row px-4 mx-4">
              <button
                style={{ flex: "1" }}
                className="btn btn-outline-primary rounded-1"
                onClick={goTOLoginScreen}
              >
                <span className="mdi mdi-arrow-left"> </span>
                Back To Login
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const ForgetSuccess = ({ history }) => {
  const goTOLoginScreen = () => history.push("/");
  return (
    <div className="card text-left p-4">
      <div className="row flex-column align-items-center">
        <img
          className="my-2"
          src={require("../../../assets/images/success_tick.png")}
          style={{ height: "4rem", width: "auto" }}
        />
        <span style={{ fontWeight: "700" }} className="my-2">
          Password Changed Successfully
        </span>
        <span className="my-2">Please login to your account</span>
        <button
          style={{ flex: "1" }}
          className="btn btn-primary btn-block rounded-0 my-2"
          onClick={goTOLoginScreen}
        >
          Login Now
        </button>
      </div>
    </div>
  );
};
